$(document).ready(function () {
    $('#countdown').countdown($('#countdown').data('date'), function (event) {
        $(this).html(event.strftime(''
            + '<span>%n</span> <span class="small">dni</span> '
            + '<span>%H</span> <span class="small">godzin</span> '
            + '<span>%M</span> <span class="small">minut</span> '
            + '<span>%S</span> <span class="small">sekund</span>'));
    });
});